import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("fl_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const imgUrl = (p) => {
  if (!p) return "";
  if (p.startsWith("http")) return p;
  return `${API}/files/${p}`;
};

// Entrega otimizada de imagens externas (Unsplash/Pexels): mesma foto,
// redimensionada e em formato moderno. URLs locais (/api/files) passam intactas.
export const optImg = (p, w = 1200) => {
  const u = imgUrl(p);
  if (!u) return u;
  try {
    const url = new URL(u);
    if (url.hostname === "images.unsplash.com") {
      url.searchParams.set("w", String(w));
      url.searchParams.set("q", "75");
      url.searchParams.set("fm", "webp");
      url.searchParams.set("fit", "max");
      url.searchParams.delete("h");
      url.searchParams.delete("dpr");
      return url.toString();
    }
    if (url.hostname === "images.pexels.com") {
      url.search = `?auto=compress&cs=tinysrgb&w=${w}`;
      return url.toString();
    }
  } catch {}
  return u;
};

export const waLink = (number, message) =>
  `https://wa.me/${(number || "").replace(/\D/g, "")}?text=${encodeURIComponent(message || "")}`;

export const formatApiError = (detail) => {
  if (detail == null) return "Algo deu errado. Tente novamente.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e && e.msg) || JSON.stringify(e)).join(" ");
  return String(detail);
};
